// Tiny fetch helpers used by storefront-critical (eagerly loaded) modules.
// Keeping axios out of the eager import graph trims ~13 KB gz off the main
// bundle; lazy chunks (cart drawer, admin) still use axios freely.
export const getJson = (url) =>
  fetch(url).then((r) => {
    if (!r.ok) throw new Error(`HTTP ${r.status}`);
    return r.json();
  });

export const postJson = (url, body) =>
  fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  }).then((r) => {
    if (!r.ok) throw new Error(`HTTP ${r.status}`);
    return r.json();
  });
